export default {
  billing_page: {
    title: 'Plan Information',
    table: {
      plan_type_row: {
        plan_type: 'Plan Type',
        extend_plan_button: 'Extend Plan',
      },
      active_users_row: {
        active_user: 'Active users',
        admin_link: 'Manage',
      },
      item_numbers_row: {
        item_numbers: 'Number of Items',
        admin_link: 'Manage',
      },
      active_orgs_row: {
        active_org: 'Organizaciones Active OrganizationsActivas',
        total_orgs: '1',
        admin_link: 'Manage',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/account/billing.js